import { Box, Divider } from "@mui/material";
import type { WorkflowSignalType } from "@entrilia/shared/api/workflowTypes";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { Workflow, WorkflowActivity } from "../../../../../api/types/workflowTypes";
import WorkflowActivityDetailContent from "./WorkflowActivityDetailContent";
import WorkflowDetailPanelHeader from "./WorkflowDetailPanelHeader";
import { getActivityDisplayStatus } from "./workflowDetailsHelpers";
import WorkflowExecutingActivityDetailContent from "./WorkflowExecutingActivityDetailContent";
import WorkflowRunDetailsContext from "./WorkflowRunDetailsContext";
import WorkflowSummaryDetailContent from "./WorkflowSummaryDetailContent";

interface Props {
  onActionExecuted: (signalType?: WorkflowSignalType) => void;
  onWorkflowUpdated: (updatedWorkflow: Workflow) => void;
  onActivitySaved: (updatedActivity: WorkflowActivity) => void;
}

const WorkflowDetailPanel = ({ onActionExecuted, onWorkflowUpdated, onActivitySaved }: Props) => {
  const { workflowDetails, steps, selectStep, selectedStep } = useDefinedContext(
    WorkflowRunDetailsContext,
    "WorkflowRunDetailsContext"
  );

  const handleSelectActivity = (activityId: string) => {
    const index = steps.findIndex(
      (item) => item.type === "activity" && item.activity.workflowActivityId === activityId
    );
    if (index !== -1) {
      selectStep(index);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", minWidth: 0 }}>
      <WorkflowDetailPanelHeader />
      <Divider />
      {selectedStep?.type === "activity" &&
        (getActivityDisplayStatus(selectedStep.activity) === "Executing" ? (
          <WorkflowExecutingActivityDetailContent activity={selectedStep.activity} />
        ) : (
          <WorkflowActivityDetailContent
            key={selectedStep.activity.workflowActivityId}
            activity={selectedStep.activity}
            onActionExecuted={onActionExecuted}
            onWorkflowUpdated={onWorkflowUpdated}
            onActivitySaved={onActivitySaved}
          />
        ))}
      {selectedStep?.type === "summary" && (
        <WorkflowSummaryDetailContent
          entries={workflowDetails.workflow.progress.entries}
          onSelectActivity={handleSelectActivity}
        />
      )}
    </Box>
  );
};

export default WorkflowDetailPanel;
